import { createI18n } from "vue-i18n";
import ru from "./locales/ru";
import kk from "./locales/kk";
import en from "./locales/en";

export const SUPPORTED_LOCALES = ["ru", "kk", "en"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

// Exported so CaptiveView.vue can check for an already-stored preference
// before applying its own (Kazakh-first) fallback for first-time visitors.
export const STORAGE_KEY = "ecoway_locale";
const DEFAULT_LOCALE: SupportedLocale = "ru";

const isSupported = (value: string | null): value is SupportedLocale =>
  !!value && (SUPPORTED_LOCALES as readonly string[]).includes(value);

function detectLocale(): SupportedLocale {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (isSupported(stored)) return stored;

  const browserLangs = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const lang of browserLangs) {
    const code = lang.toLowerCase().split("-")[0];
    if (code === "kk" || code === "kz") return "kk";
    if (code === "en") return "en";
    if (code === "ru") return "ru";
  }
  return DEFAULT_LOCALE;
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: detectLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: { ru, kk, en },
});

export function setLocale(locale: SupportedLocale) {
  i18n.global.locale.value = locale;
  localStorage.setItem(STORAGE_KEY, locale);
  document.documentElement.lang = locale;
}

document.documentElement.lang = i18n.global.locale.value;

export default i18n;
